import { useState, useEffect } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import { Grid, Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from '@mui/icons-material/Add';
import { getCuentasBancarias, getCuentasBancariasPaginated, deleteCuentasBancarias } from "../helpers/CuentasBancariasData";
import { GenericCard } from "src/general_components/GenericCard";
import { FormularioDinamicoModelos } from "src/general_components/FormularioDinamicoModelos";
import { getTablaEstructura, getDataSelect } from "src/hooks/structureTable";

export const CuentasBancariasList = (data) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [createButton, setCreateButton] = useState(false);
    const [dataEdit, setDataEdit] = useState([]);
    const [records, setRecords] = useState([]);
    const [gridKey, setGridKey] = useState(0);

    const listName = "Cuentas Bancarias";
    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.3 },  // la propiedad flex permite setear responsivamente el tamaño de la columna 
        { field: 'cbu', headerName: 'CBU', flex: 1 },
        { field: 'alias', headerName: 'Alias', flex: 1 },
        { field: 'id_maestros_bancos', headerName: 'Banco', flex: 1 },
        { field: 'descripcion', headerName: 'Descripcion', flex: 1 }

    ];
    const modelo = "cuentas_bancarias"
    const valuesDefaultForm = { id_cuentas: data.params.id_cuentas };

    const [formData, setFormData] = useState({});

    const [options, setOptions] = useState({
        cols: columns,
        get: getCuentasBancarias,
        getPaginated: getCuentasBancariasPaginated,
        pageSize: [5, 10, 25],
        edit: true,
        delete: deleteCuentasBancarias,
        limit: 50,
        filter: true,
        exportData: true,
        server: true,
        idElementData: data.params.id_cuentas,

        //DATOS PARA EL FORMULARIO
        createButton: createButton,
        setCreateButton: setCreateButton,
        setDataEdit: setDataEdit,
        setListRecords: setRecords,
        mobileComponent: ({ row }) => (
            <GenericCard
                row={row}
                columns={columns}
                onEdit={(item) => {
                    setDataEdit(item);
                    setCreateButton(true);
                }}
                onDelete={async (id, params) => {
                    const resultado = await deleteCuentasBancarias(id, params, data.params.id_cuentas);
                    if (resultado) window.location.reload();
                }}
            />
        )
    });

    useEffect(() => {

        const filtrarCampos = async (formDataResponse) => {
            const camposFiltrados = {};
            for (const fieldName in formDataResponse) {
                if (fieldName.includes('id_')) {
                    const palabraExtraida = fieldName.replace('id_', ''); // Cortar "id_"
                    const valorLocalStorage = JSON.parse(localStorage.getItem("siam-" + palabraExtraida))?.[palabraExtraida];

                    if (valorLocalStorage) {
                        // Mapear cada objeto del valorLocalStorage para tener solo "id", "nombre" y manejar casos
                        const opcionesFiltradas = valorLocalStorage.map(({ id, nombre, descripcion, label, detalle, unidad_monetaria }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || unidad_monetaria || 'Sin Nombre', // Prioridad: nombre > descripcion > label
                        }));

                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    } else {
                        const datosSelect = await getDataSelect(palabraExtraida);

                        // / Mapear cada objeto del valorLocalStorage para tener solo "id", "nombre" y manejar casos
                        const opcionesFiltradas = datosSelect.map(({ id, nombre, descripcion, label, detalle, unidad_monetaria }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || unidad_monetaria || 'Sin Nombre', // Prioridad: nombre > descripcion > label
                        }));

                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    }
                }
            }



            // Combina formData con camposFiltrados
            let camposFinal = { ...formDataResponse, ...camposFiltrados, };


            if (camposFinal.id) {
                delete camposFinal.id;
            }

            // Eliminar propiedades de camposFinal si coinciden con valuesDefaultForm
            Object.keys(valuesDefaultForm).forEach((key) => {
                delete camposFinal[key];
            });

            return camposFinal;
        };
        const getEstructuraTabla = async () => {
            // setIsLoadingData(true);
            let response = await getTablaEstructura(modelo);

            if (response.status === "true") {
                const formDataResponse = response.wsResponse;
                const camposFiltrados = await filtrarCampos(formDataResponse);
                setFormData(camposFiltrados);
            }

        };
        getEstructuraTabla();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSetOptions = (newOptions) => {
        if (newOptions.refresh) {
            setGridKey(prev => prev + 1);
            setOptions({ ...newOptions, refresh: false });
        } else {
            setOptions(newOptions);
        }
    };

    //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
    //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
    //EL BUTTONMETADATOS SOLO ES PARA ESTE CASO, VERIFICAR CADA OCASION.
    if (
        createButton === false &&
        dataEdit.id !== undefined
    ) {
        setDataEdit([]);
    }

    return (
        <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
            <>
                {isMobile && !createButton && (
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => {
                                setCreateButton(true);
                                setDataEdit([]);
                            }}
                            fullWidth
                        >
                            Agregar Nuevo
                        </Button>
                    </Box>
                )}
                {isMobile && !createButton && records.length === 0 && (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Typography variant="body1" color="textSecondary">
                            No hay registros para mostrar
                        </Typography>
                    </Box>
                )}

                <ListTablePaginated key={gridKey} options={options} />
                <FormularioDinamicoModelos
                    data={dataEdit}
                    createButton={createButton}
                    listName={listName}
                    setCreateButton={setCreateButton}
                    setOptions={handleSetOptions}
                    options={options}
                    formData={formData}
                    modelo={modelo}
                    dataDefault={valuesDefaultForm}
                />
            </>
        </Grid>
    );
};

